import React from 'react';
import type {DataValue, Part} from 'schemaDefinition/types';
import type {BaseFieldProps} from '../types';
import {ValueLayout} from './ValueLayout';

type Props<TPart extends Part, TValue extends DataValue> = Pick<
  BaseFieldProps<TPart, TValue | TValue[]>,
  'part' | 'layoutDirection'
> & {
  renderValue: () => React.ReactNode | null;
};

export const SingleValue = <TPart extends Part, TValue extends DataValue>({
  part,
  layoutDirection,
  renderValue,
}: Props<TPart, TValue>) => {
  return (
    <ValueLayout
      renderValue={renderValue}
      part={part}
      layoutDirection={layoutDirection}
    />
  );
};
